import React from "react";
import { Icon } from "@iconify/react";

const ScorekeeperIcon = () => (
  <Icon icon="lucide:clipboard-list" width={18} height={18} />
);

export default ScorekeeperIcon;
